import { useEffect } from 'react';
import { fetchTabs, getTokenFromHash } from '../api/tabsApi';
import { Box } from '@chakra-ui/react';
import { useSelector } from 'react-redux';
import { TState, useActions } from '../redux/store';

const ExternalForm = ({ hash }: { hash: string }) => {
  const theme = useSelector((state: TState) => state.theme);

  const {
    setModalType,
    setModalData,
    setRowData,
    setToken,
    setCurrentTab,
    getInputs,
    getDocumentList,
  } = useActions();

  // const [data, setData] = useState<any>({});

  useEffect(() => {
    const call = async () => {
      const resp = await getTokenFromHash(hash);
      setToken(resp.token);

      await getInputs();
      await getDocumentList();

      const tabs = await fetchTabs({
        parentId: resp.parentId,
        tabId: resp.tabId,
      });

      setCurrentTab(tabs.currentTab);

      setRowData(resp.data);
      setModalType('editEntry');
      setModalData((md: any) => ({ ...md, isExternal: true }));
    };

    call();
  }, []);

  return (
    <Box
      h='100vh'
      overflow='hidden'
      bgGradient={`linear(to-r, ${theme.light}, ${theme.normal})`}
    >
      {/* <Box
        h='100vh'
        overflow='auto'
        w={{ sm: '100%', lg: '70%' }}
        margin='auto'
        bg={'white'}
      >
        e
      </Box> */}
    </Box>
  );
};

export default ExternalForm;
